import script from "./PageMappingGrantCollectionCategoryUrssafEditionDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageMappingGrantCollectionCategoryUrssafEditionDetail.vue?vue&type=script&setup=true&lang=ts"

import "./PageMappingGrantCollectionCategoryUrssafEditionDetail.vue?vue&type=style&index=0&id=675a2558&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-675a2558"]])

export default __exports__